import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

type SensorIdentity = {
  Location?: string | null;
  deviceID?: string | null;
  deviceEUI: string;
};

const identityTitle = (sensor: SensorIdentity) => {
  const loc = (sensor.Location || '').trim();
  const locationLine = loc && loc !== '---' ? loc : '—';
  const deviceID = (sensor.deviceID || '').trim() || '—';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {locationLine}
      </Typography>
      <Typography variant="caption" component="div">
        deviceID: {deviceID}
      </Typography>
      <Typography variant="caption" component="div">
        deviceEUI: {sensor.deviceEUI}
      </Typography>
    </Box>
  );
};

/** Hover identity: assigned location/name, then deviceID and deviceEUI. */
const SensorIdentityTooltip: React.FC<{
  sensor: SensorIdentity;
  children: React.ReactElement;
}> = ({ sensor, children }) => (
  <Tooltip
    title={identityTitle(sensor)}
    arrow
    placement="top"
    slotProps={{
      popper: {
        disablePortal: false,
        sx: { zIndex: (theme) => theme.zIndex.tooltip },
        modifiers: [
          {
            name: 'preventOverflow',
            options: { boundary: 'viewport', altAxis: true },
          },
        ],
      },
    }}
  >
    {children}
  </Tooltip>
);

export default SensorIdentityTooltip;
